module.exports = __webpack_public_path__ + "images/services_overview.png";